import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

type IncidentCategory = {
  name: string
  reasons: Array<{ id: string; label: string }>
}

type ReverIncidentSelectProps = {
  onReasonChanged: (
    selectedReasonId: string | null,
    selectedReasonLabel: string | null
  ) => void
}

const reasonsData: IncidentCategory[] = [
  {
    name: 'process_details_page.report_incident.reasons.rever_categories.collection',
    reasons: [
      {
        id: 'schedule_collection',
        label:
          'process_details_page.report_incident.reasons.rever_reasons.schedule_collection'
      },
      {
        id: 'already_collected',
        label:
          'process_details_page.report_incident.reasons.rever_reasons.already_collected'
      },
      {
        id: 'other_collection',
        label:
          'process_details_page.report_incident.reasons.rever_reasons.other_collection'
      }
    ]
  },
  {
    name: 'process_details_page.report_incident.reasons.rever_categories.refund',
    reasons: [
      {
        id: 'no_refund',
        label:
          'process_details_page.report_incident.reasons.rever_reasons.no_refund'
      },
      {
        id: 'gift_card_issues',
        label:
          'process_details_page.report_incident.reasons.rever_reasons.gift_card_issues'
      },
      {
        id: 'other_refund',
        label:
          'process_details_page.report_incident.reasons.rever_reasons.other_refund'
      }
    ]
  },
  {
    name: 'process_details_page.report_incident.reasons.rever_categories.compensation',
    reasons: [
      {
        id: 'cancel_gift_card',
        label:
          'process_details_page.report_incident.reasons.rever_reasons.cancel_gift_card'
      },
      {
        id: 'cancel_exchange',
        label:
          'process_details_page.report_incident.reasons.rever_reasons.cancel_exchange'
      },
      {
        id: 'other_compensation',
        label:
          'process_details_page.report_incident.reasons.rever_reasons.other_compensation'
      }
    ]
  },
  {
    name: 'process_details_page.report_incident.reasons.rever_categories.other',
    reasons: [
      {
        id: 'other_incident',
        label:
          'process_details_page.report_incident.reasons.rever_reasons.other_incident'
      }
    ]
  }
]

const ReverIncidentSelect: React.FC<ReverIncidentSelectProps> = ({
  onReasonChanged
}) => {
  const { t } = useTranslation()
  const [selectedReason, setSelectedReason] = useState<string | null>(null)

  const handleSelectionChange = (reasonId: string, reasonLabel: string) => {
    setSelectedReason(reasonId)
    onReasonChanged(reasonId, reasonLabel)
  }

  return (
    <div className="space-y-4">
      {reasonsData.map((category) => (
        <div key={category.name}>
          <p className="mb-0.5 text-sm font-semibold uppercase tracking-wide text-neutral-400">
            {t(category.name)}
          </p>
          <div className="grid grid-cols-2 gap-x-4 gap-y-0.5">
            {category.reasons.map((reason) => (
              <label
                key={reason.id}
                className="flex items-start gap-2 text-base"
              >
                <input
                  type="radio"
                  name="reason"
                  className="mt-1.5 shrink-0"
                  value={reason.id}
                  checked={selectedReason === reason.id}
                  onChange={() =>
                    handleSelectionChange(reason.id, reason.label)
                  }
                />
                {t(reason.label)}
              </label>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}

export default ReverIncidentSelect
